import config from "@/config"
import http from "@/utils/request"

export default {
	menu: {
		myMenus: {
			url: `${config.MAIN_URL}/system/menu/my/1.6.1`,
			name: "获取我的菜单",
			get: async function () {
				return await http.get(this.url);
			}
		},
		list: {
			url: `${config.MAIN_URL}/system/menu/list`,
			name: "获取菜单",
			get: async function () {
				return await http.get(this.url);
			}
		}
	},
	dic: {
		tree: {
			url: `${config.MAIN_URL}/system/dic/tree`,
			name: "获取字典树",
			get: async function () {
				return await http.get(this.url);
			}
		},
		list: {
			url: `${config.MAIN_URL}/system/dic/list`,
			name: "字典明细",
			get: async function (params) {
				return await http.get(this.url, params);
			}
		},
		get: {
			url: `${config.MAIN_URL}/system/dic/get`,
			name: "获取字典数据",
			get: async function (params) {
				return await http.get(this.url, params);
			}
		}
	},
	role: {
		list: {
			url: `${config.MAIN_URL}/system/role/list2`,
			name: "获取角色列表",
			get: async function (params) {
				return await http.get(this.url, params);
			}
		}
	},
	// 菜单树管理
	menuTree: {
		url: {
			list: {
				url: `${config.MAIN_URL}/permission/menu/management/getMenuTreeByVersion`,
				name: "根据版本获取菜单树",
			},
			versions: {
				url: `${config.MAIN_URL}/permission/menu/management/getMenuTreeVersions`,
				name: "获取版本号列表",
			},
			createMenuTreeByOldVersion: {
				url: `${config.MAIN_URL}/permission/menu/createMenuTreeByOldVersion`,
				name: "根据旧版本号复制菜单树",
			},
			add: {
				url: `${config.MAIN_URL}/permission/menu/addMenuTreeEntry`,
				name: "菜单树节点新增",
			},
			update: {
				url: `${config.MAIN_URL}/permission/menu/updateMenuTreeEntry`,
				name: "菜单树节点修改",
			},
			delete: {
				url: `${config.MAIN_URL}/permission/menu/deleteMenuTreeEntry`,
				name: "菜单删除",
			},
			sort: {
				url: `${config.MAIN_URL}/permission/menu/updateMenuTreeSort`,
				name: "菜单排序修改",
			},
		},
		get: async function (params) {
			return await http.get(this.url.list.url, params);
		},
		getMenuTreeVersions: async function (params) {
			return await http.get(this.url.versions.url, params);
		},
		createMenuTreeByOldVersion: async function (params) {
			return await http.post(this.url.createMenuTreeByOldVersion.url, params);
		},
		post: async function (params) {
			return await http.post(this.url.add.url, params);
		},
		put: async function (params) {
			return await http.put(this.url.update.url, params);
		},
		delete: async function (params) {
			return await http.delete(this.url.delete.url + params);
		},
		sort: async function (params) {
			return await http.post(this.url.sort.url, params);
		},
	},
	company:{
		app: {
			url: `${config.MAIN_URL}/api/v1/company/app`,
			name: "查询当前企业选中的应用",
			get: async function () {
				return await http.get(this.url);
			}
		},
		menuTree: {
			url: `${config.MAIN_URL}/api/v1/company/menuTree`,
			name: "查询当前企业的菜单树",
			get: async function (params) {
				return await http.get(this.url, params);
			}
		},
	},
	// 角色管理管理（运控端实现角色管理）
	role1: {
		url: {
			list: {
				url: `${config.MAIN_URL}/permission/role/roleList`,
				name: "角色列表",
			},
			add: {
				url: `${config.MAIN_URL}/permission/role/addRole`,
				name: "角色新增",
			},
			update: {
				url: `${config.MAIN_URL}/permission/role/updateRole`,
				name: "角色修改",
			},
			delete: {
				url: `${config.MAIN_URL}/permission/role/deleteRole`,
				name: "角色删除",
			},
			band: {
				url: `${config.MAIN_URL}/permission/role/bandRoleMenus`,
				name: "角色菜单绑定",
			},
			getRoleMenus: {
				url: `${config.MAIN_URL}/permission/role/getRoleMenus`,
				name: "角色菜单获取",
			},
			getRoleMenuIds: {
				url: `${config.MAIN_URL}/permission/role/getRoleMenuIds`,
				name: "获取角色菜单id列表",
			}

		},
		get: async function (params) {
			return await http.get(this.url.list.url, params);
		},
		post: async function (params) {
			return await http.post(this.url.add.url, params);
		},
		put: async function (params) {
			return await http.put(this.url.update.url, params);
		},
		delete: async function (params) {
			return await http.delete(this.url.delete.url + params);
		},
		band: async function (params) {
			return await http.post(this.url.band.url, params);
		},
		getRoleMenus: async function (params) {
			return await http.get(this.url.getRoleMenus.url, params);
		},
		getRoleMenuIds: async function (params) {
			return await http.get(this.url.getRoleMenuIds.url, params);
		},

	},
	dept: {
		list: {
			url: `${config.MAIN_URL}/system/dept/list`,
			name: "获取部门列表",
			get: async function (params) {
				return await http.get(this.url, params);
			}
		}
	},
	user: {
		list: {
			url: `${config.MAIN_URL}/system/user/list`,
			name: "获取用户列表",
			get: async function (params) {
				return await http.get(this.url, params);
			}
		},
		names: {
			url: `${config.MAIN_URL}/user/v1/names`,
			name: "获取所有的用户名",
			get: async function (params) {
				return await http.get(this.url + params);
			}
		},
		save: {
			url: `${config.MAIN_URL}/admin/api/user`,
			name: "新增用户",
			post: async function (params) {
				return await http.post(this.url, params);
			},
			put: async function (params) {
				return await http.put(this.url, params);
			},
		},
		changePwd: {
			url: `${config.MAIN_URL}/admin/api/user/password`,
			name: "用户修改密码",
			put: async function (params) {
				return await http.put(this.url, params);
			}
		},
		info: {
			url: `${config.MAIN_URL}/user/v1/info`,
			name: "获取用户列表",
			get: async function (params) {
				return await http.get(this.url + params);
			}
		},

	},
	app: {
		list: {
			url: `${config.MAIN_URL}/system/app/list`,
			name: "应用列表",
			get: async function () {
				return await http.get(this.url);
			}
		}
	},
	log: {
		list: {
			url: `${config.MAIN_URL}/system/log/list`,
			name: "日志列表",
			get: async function (params) {
				return await http.get(this.url, params);
			}
		}
	},
	table: {
		list: {
			url: `${config.MAIN_URL}/system/table/list`,
			name: "表格列管理列表",
			get: async function (params) {
				return await http.get(this.url, params);
			}
		},
		info: {
			url: `${config.MAIN_URL}/system/table/info`,
			name: "表格列管理详情",
			get: async function (params) {
				return await http.get(this.url, params);
			}
		}
	},
	tasks: {
		list: {
			url: `${config.MAIN_URL}/system/tasks/list`,
			name: "系统任务管理",
			get: async function (params) {
				return await http.get(this.url, params);
			}
		}
	}
}
